import React from "react";

const BUTTON_TYPE = "button";

interface SuggestedPromptsProps {
  prompts: string[];
  onSelect: (prompt: string) => void;
}

export const SuggestedPrompts = ({ prompts, onSelect }: SuggestedPromptsProps): React.ReactElement => (
  <div className="restaurant-chatbot-suggested-prompts">
    {prompts.map((prompt, index) => (
      <button
        key={`${prompt}-${index}`}
        className="restaurant-chatbot-suggested-prompt"
        type={BUTTON_TYPE}
        onClick={() => onSelect(prompt)}
      >
        {prompt}
      </button>
    ))}
  </div>
);
